import React from 'react';

import { WizardContext } from './WizardContext';
import { IStepWrapperProps } from './StepWrapper.types';

export class StepWrapper extends React.Component<IStepWrapperProps> {
  static contextType = WizardContext;

  getStepProps = () => {
    const {
      stepConfig,
      isActive,
      currentStep,
      totalSteps,
      firstStep,
      lastStep,
      goToStep,
    } = this.props;

    return {
      ...(stepConfig.props || {}),
      isActive,
      currentStep,
      totalSteps,
      firstStep,
      lastStep,
      goToStep,
      nextStep: this.handleNextStep,
      previousStep: this.handlePreviousStep,
    };
  };

  handleNextStep = () => {
    const { config, answers } = this.context;
    const { currentStep, totalSteps, goToStep } = this.props;

    let nextIndex = currentStep;
    while (nextIndex < totalSteps) {
      const step = config.steps[nextIndex];
      if (!step.disabled || !step.disabled(answers)) {
        break;
      }
      nextIndex++;
    }

    const nextStep = nextIndex + 1;
    return this.context.validate().then(() => {
      goToStep(nextStep);
    });
  };

  handlePreviousStep = () => {
    const { config, answers } = this.context;
    const { currentStep, goToStep } = this.props;

    let index = currentStep - 2;
    while (index >= 0) {
      const step = config.steps[index];
      if (!step.disabled || !step.disabled(answers)) {
        break;
      }
      index--;
    }

    goToStep(index + 1);
  };

  render() {
    const { component: StepComponent } = this.props.stepConfig;
    return React.isValidElement(StepComponent) ? (
      React.cloneElement(StepComponent, this.getStepProps())
    ) : (
      <StepComponent {...this.getStepProps()} />
    );
  }
}
